import React from "react";
import { useNavigate } from "react-router-dom";
import { Btn, Card, Overline, Tile } from "../../ForBrands/ui/BrandUI";
import { MobileCard } from "../../ForBrands/ui/mobile/MobileUI";
import { usePhoneTheme } from "../../ForBrands/useIsPhone";

// Coach Mode · CacheShare™ gates: the subscription gate and the gate for a
// coach whose account is not admin-verified yet (no team data until then).
// On phones they sit in the phone card (16px radius, 18px sides, the
// subtle border) with 52px buttons; the layout inside is the same.

const LockBadge = () => (
  <span className="flex h-16 w-16 items-center justify-center rounded-full bg-bm-subtle">
    <svg className="h-7 w-7 text-bm-orange" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    </svg>
  </span>
);

const GateCard = ({ phone, children }) =>
  phone ? (
    <MobileCard className="items-center !gap-4 !py-12 text-center">{children}</MobileCard>
  ) : (
    <Card className="flex flex-col items-center gap-4 py-12 text-center">{children}</Card>
  );

// Subscription gate in the V2 language (Core / Pro / Premium / admin pass).
export const AllocationAccessGate = () => {
  const navigate = useNavigate();
  const phone = usePhoneTheme();
  return (
    <GateCard phone={phone}>
      <LockBadge />
      <div className="flex flex-col gap-1">
        <Overline>CacheShare™</Overline>
        <h2 className="bm-h-m text-bm-ink">CacheShare™ is a Core, Pro and Premium feature</h2>
        <p className="mx-auto max-w-[560px] bm-body-m text-bm-muted">
          Model how a NIL pool splits across your roster from CacheValue™, add players from any team, adjust each anticipated payout and export
          the plan for your program.
        </p>
      </div>
      <div className="grid w-full max-w-[640px] grid-cols-1 gap-3 text-left sm:grid-cols-3">
        <Tile label="Core" value="$900/mo" sub="or $10,000 a year" />
        <Tile label="Pro" value="$1,800/mo" sub="or $20,000 a year" />
        <Tile label="Premium" value="Custom" sub="per sport, with AI insights" />
      </div>
      <Btn size={phone ? "lg" : undefined} onClick={() => navigate("/coach/billing")}>
        See plans
      </Btn>
    </GateCard>
  );
};

export const AllocationPendingGate = ({ status }) => {
  const navigate = useNavigate();
  const phone = usePhoneTheme();
  const rejected = status === "rejected";
  return (
    <GateCard phone={phone}>
      <LockBadge />
      <div className="flex flex-col gap-1">
        <Overline>{rejected ? "Verification rejected" : "Verification pending"}</Overline>
        <h2 className="bm-h-m text-bm-ink">CacheShare™ opens once your coach account is verified</h2>
        <p className="mx-auto max-w-[560px] bm-body-m text-bm-muted">
          {rejected
            ? "We could not verify your coach account. Check your team details on your profile, then contact support to try again."
            : "Our team checks every coach before team data opens. You will get an email as soon as your account is verified."}
        </p>
      </div>
      <Btn variant="secondary" size={phone ? "lg" : undefined} onClick={() => navigate("/coach/profile")}>
        Go to your profile
      </Btn>
    </GateCard>
  );
};
